import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { usePlatformAuth } from '@/hooks/usePlatformAuth'

const navGroups = [
    {
        title: 'Administración Sistema', items: [
            { to: '/platform/dashboard', label: 'Dashboard' },
            { to: '/platform/tenants', label: 'Tenants' },
            { to: '/platform/health', label: 'Salud servicios' },
        ],
    },
    {
        title: 'Auditoría y Seguridad', items: [
            { to: '/platform/audit', label: 'Auditoría' },
            { to: '/platform/security', label: 'MFA' },
        ],
    },
    {
        title: 'Finanzas', items: [
            { to: '/platform/billing', label: 'Finanzas' },
            { to: '/platform/plans', label: 'Planes y módulos' },
        ],
    },
    {
        title: 'Comercial & BI', items: [
            { to: '/platform/leads', label: 'Leads' },
            { to: '/platform/accounts', label: 'Cuentas' },
            { to: '/platform/pipeline', label: 'Pipeline (Kanban)' },
            { to: '/platform/bi', label: 'BI Ejecutivo' },
        ],
    },
    {
        title: 'Desarrollo', items: [
            { to: '/platform/maintenance', label: 'Mantenimiento técnico' },
        ],
    },
]

export default function PlatformLayout() {
    const { platformUser, logout } = usePlatformAuth()
    const navigate = useNavigate()

    const onLogout = async () => {
        await logout()
        navigate('/platform/login', { replace: true })
    }

    return (
        <div className="flex min-h-screen bg-slate-900 text-slate-100">
            <aside className="flex w-60 flex-col border-r border-slate-800 bg-slate-950">
                <div className="px-5 py-5">
                    <div className="text-lg font-semibold">VANTAK</div>
                    <div className="text-xs text-slate-400">Administración de Plataforma</div>
                </div>
                <nav className="flex-1 space-y-4 overflow-y-auto px-3">
                    {navGroups.map((g) => (
                        <div key={g.title}>
                            <div className="px-3 pb-1 text-[10px] font-semibold uppercase tracking-wider text-slate-500">{g.title}</div>
                            <div className="space-y-1">
                                {g.items.map((n) => (
                                    <NavLink key={n.to} to={n.to}
                                        className={({ isActive }) =>
                                            `block rounded-md px-3 py-2 text-sm ${isActive ? 'bg-indigo-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}>
                                        {n.label}
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    ))}
                </nav>
                <div className="border-t border-slate-800 px-4 py-4 text-sm">
                    <div className="truncate text-slate-300">{platformUser?.fullName}</div>
                    <div className="truncate text-xs text-slate-500">{platformUser?.email}</div>
                    <button onClick={onLogout}
                        className="mt-3 w-full rounded-md border border-slate-700 py-1.5 text-slate-300 hover:bg-slate-800">
                        Salir
                    </button>
                </div>
            </aside>
            <main className="flex-1 overflow-auto p-8">
                <Outlet />
            </main>
        </div>
    )
}
